import React from 'react';
import { useIntl } from 'react-intl';
import { DatedEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { SPHL } from '@models';
import { EvidenceApiUrl, Permission } from '@enums';
import { useEvidencePermission } from '@utils';
import { useColumns } from './sphl-columns';
import { Fields } from './sphl-fields';
import { useValidationSchema } from './sphl-schema';

export function SPHLEvidence() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();
  const columns = useColumns();

  const btnPermissions = useEvidencePermission({
    options: {
      NEW: [Permission.SPHL_WRITE],
      EDIT: [Permission.SPHL_WRITE],
      REMOVE: [Permission.SPHL_WRITE],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<SPHL>({
    version: 1,
    identifier: 'SPHL',
    apiProps: {
      url: EvidenceApiUrl.SPHL,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__SPHL__TABLE__TITLE',
        defaultMessage: 'SPHL',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__SPHL__DETAIL__TITLE',
          defaultMessage: 'SPHL',
        }),
        subtitle: (type) => type?.name ?? '',
        showBtn: btnPermissions,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
      initNewItem: () => ({ active: true } as SPHL),
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
